const CLARITY_ID = process.env.REACT_APP_CLARITY_PROJECT_ID;

// Avoid session replay on auth / password / confidential reporting surfaces.
const BLOCKED_PATH_SNIPPETS = [
	'/signin',
	'/reset-password',
	'/set-password',
	'/azure_callback',
	'/logout',
	'/report-anonymously',
	'/report-confidentially',
];

export function shouldTrackClarity() {
	if (!CLARITY_ID) return false;
	const path = window.location.pathname.toLowerCase();
	return !BLOCKED_PATH_SNIPPETS.some((snippet) => path.includes(snippet));
}

export function initClarity() {
	if (!shouldTrackClarity()) return;
	if (typeof window.clarity === 'function') return;

	(function (c, l, a, r, i, t, y) {
		c[a] =
			c[a] ||
			function () {
				(c[a].q = c[a].q || []).push(arguments);
			};
		t = l.createElement(r);
		t.async = 1;
		t.src = 'https://www.clarity.ms/tag/' + i;
		y = l.getElementsByTagName(r)[0];
		y.parentNode.insertBefore(t, y);
	})(window, document, 'clarity', 'script', CLARITY_ID);
}
